<template>
  <div>
    <svg version="1.1" class="amaze-squiggle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
       viewBox="0 0 75 20" style="enable-background:new 0 0 75 20;" xml:space="preserve">
    <g>
      <g>
        <g>
          <path v-bind:class="fillColor" d="M5,15.7c3.7-3.5,6.9-7.3,9.8-11.5c1.1-1.6-1.5-3.1-2.6-1.5c-2.7,4-5.8,7.6-9.3,10.9C1.5,14.9,3.6,17,5,15.7
            L5,15.7z"/>
        </g>
      </g>
      <g>
        <g>
          <path v-bind:class="fillColor" d="M12.1,15.7c3.7-3.5,6.9-7.3,9.8-11.5C23,2.6,20.4,1,19.3,2.6c-2.7,4-5.8,7.6-9.3,10.9
            C8.6,14.9,10.7,17,12.1,15.7L12.1,15.7z"/>
        </g>
      </g>
      <g>
        <g>
          <path v-bind:class="fillColor" d="M19,17.1c1.2-1.2,2.3-2.4,3.4-3.8c0.9-1.1,1.8-3.3,3.2-3.8c1.8-0.7,1-3.6-0.8-2.9C23,7.3,22,8.6,21,10.1
            c-1.2,1.8-2.6,3.4-4.1,4.9C15.5,16.3,17.6,18.4,19,17.1L19,17.1z"/>
        </g>
      </g>
      <g>
        <g>
          <path v-bind:class="fillColor" d="M25.1,18c3.7-3.5,6.9-7.3,9.8-11.5C36,4.9,33.4,3.4,32.3,5c-2.7,4-5.8,7.6-9.3,10.9
            C21.6,17.3,23.7,19.4,25.1,18L25.1,18z"/>
        </g>
      </g>
      <g>
        <g>
          <path v-bind:class="fillColor" d="M34.5,15.7c3.7-3.5,6.9-7.3,9.8-11.5c1.1-1.6-1.5-3.1-2.6-1.5c-2.7,4-5.8,7.6-9.3,10.9
            C31,14.9,33.1,17,34.5,15.7L34.5,15.7z"/>
        </g>
      </g>
      <g>
        <g>
          <path v-bind:class="fillColor" d="M41.4,17.1c1.2-1.2,2.3-2.4,3.4-3.8c0.9-1.1,1.8-3.3,3.2-3.8c1.8-0.7,1-3.6-0.8-2.9c-1.8,0.7-2.7,2-3.7,3.5
            c-1.2,1.8-2.6,3.4-4.1,4.9C37.9,16.3,40,18.4,41.4,17.1L41.4,17.1z"/>
        </g>
      </g>
      <g>
        <g>
          <path v-bind:class="fillColor" d="M51,15.7c3.7-3.5,6.9-7.3,9.8-11.5c1.1-1.6-1.5-3.1-2.6-1.5c-2.7,4-5.8,7.6-9.3,10.9
            C47.5,14.9,49.6,17,51,15.7L51,15.7z"/>
        </g>
      </g>
      <g>
        <g>
          <path v-bind:class="fillColor" d="M58.1,15.7c3.7-3.5,6.9-7.3,9.8-11.5C69,2.6,66.4,1,65.3,2.6c-2.7,4-5.8,7.6-9.3,10.9
            C54.6,14.9,56.7,17,58.1,15.7L58.1,15.7z"/>
        </g>
      </g>
      <g>
        <g>
          <path v-bind:class="fillColor" d="M65,17.1c1.2-1.2,2.3-2.4,3.4-3.8c0.9-1.1,1.8-3.3,3.2-3.8c1.8-0.7,1-3.6-0.8-2.9C69,7.3,68,8.6,67,10.1
            c-1.2,1.8-2.6,3.4-4.1,4.9C61.5,16.3,63.6,18.4,65,17.1L65,17.1z"/>
        </g>
      </g>
    </g>
    </svg>
  </div>
</template>

<script>

export default {
  props: ['fillColor'],
  data () {
    return {}
  },
  methods: {
  },
  computed: {
  }
}
</script>
